(() => {
  const prefix = '/s/files/1/0775/2571/3149/files/';
  const brand = 'https://www.techtool.com';
  function normalize(link) {
    const raw = link.getAttribute('href');
    if (!raw) return;
    let url;
    try { url = new URL(raw, document.baseURI); } catch { return; }
    if (!['https:', 'http:'].includes(url.protocol)) return;
    if (url.hostname !== 'cdn.shopify.com' || !url.pathname.startsWith(prefix)) return;
    link.setAttribute('href', brand + '/cdn/shop/files/' + url.pathname.slice(prefix.length) + url.search + url.hash);
  }
  function scan(root) {
    if (root.nodeType !== 1 && root.nodeType !== 9) return;
    if (root.matches?.('a[href], area[href]')) normalize(root);
    root.querySelectorAll('a[href], area[href]').forEach(normalize);
  }
  scan(document);
  new MutationObserver(records => {
    for (const record of records) {
      if (record.type === 'attributes') normalize(record.target);
      else record.addedNodes.forEach(scan);
    }
  }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['href'] });
  document.addEventListener('click', event => {
    const link = event.target.closest?.('a[href], area[href]');
    if (link) normalize(link);
  }, true);
})();
